import {
  Button,
  HStack,
  Text,
  Collapse,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import ColumnManager from "../column_manager";

const ColumnFilters = observer(() => {
  const { pageStore } = useStores();

  return (
    <>
      <Collapse
        in={pageStore.open_filter}
        animateOpacity
        style={{ overflow: pageStore.open_filter ? "visible" : "hidden" }}
      >
        <HStack
          textColor="white"
          width="100%"
          align="start"
          gap="20px"
          mb={4}
          flexWrap="wrap"
        >
          <ColumnManager
            report="orderSuppliers"
            columns={pageStore.columnConfigOrderSuppliers}
            onChange={(newColumns) => pageStore.setColumnConfigOrderSuppliers(newColumns)}
          />
        </HStack>
      </Collapse>

      <HStack
        justify="flex-start"
        spacing={6}
        mb={4}
        borderBottom="1px solid #444"
        pb={3}
        w="full"
        align="center"
      >
        <Button
          size="sm"
          bg="#333"
          color="white"
          onClick={() => pageStore.setOpenFilters(!pageStore.open_filter)}
          _hover={{ bg: "#444" }}
          leftIcon={pageStore.open_filter ? <span>−</span> : <span>+</span>}
          flexShrink={0}
        >
          {pageStore.open_filter ? "Скрыть фильтры" : "Открыть фильтры"}
        </Button>

        <HStack spacing={4} flex="1">
          <Text fontSize="12px" fontWeight="bold" color="gray.400" whiteSpace="nowrap">
            Высота строк: {pageStore.rowHeight}
          </Text>

          <HStack spacing={2} w="200px">
            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.max(0, pageStore.rowHeight - 1))}
            >
              -
            </Button>
            <Slider
              min={0}
              max={10}
              step={1}
              value={pageStore.rowHeight}
              onChange={(v) => pageStore.setRowHeight(v)}
              colorScheme="green"
            >
              <SliderTrack bg="#444">
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb boxSize={3} />
            </Slider>
            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.min(10, pageStore.rowHeight + 1))}
            >
              +
            </Button>
          </HStack>

          <Text fontSize="12px" color="gray.400" fontWeight="600" whiteSpace="nowrap">
            Время запроса: {pageStore.request_time.toFixed(2)} сек.
          </Text>
        </HStack>
      </HStack>
    </>
  );
});

export default ColumnFilters;
